import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';
import { AudioPlayer } from '../AudioPlayer';
import { Accordion } from '../../Accordeon';
import { InfoContainer } from '../AudioPlayer/components/InfoContainer';

import styles from './styles.module.scss';

const ListContainer = ({ children }) => (
	<div className={styles.listContainer}>{children}</div>
);
const ListItem = ({ track, playTrack, isActiveTrack }) => (
	<button
		type="button"
		className={cx(styles.listItems, { [styles.isActiveTrack]: isActiveTrack })}
		onClick={() => playTrack(track?.id)}
	>
		{track?.title}
	</button>
);

const AccordionControl = ({ isOpen }) => (
	<div className={styles.headerToggler}>
		<button
			type="button"
			className={cx(styles.openCloseButton, { [styles.reversed]: !isOpen })}
		>
			<Icon icon="audio-arrow" />
		</button>
	</div>
);

const AccordionHeader = ({ track, playTrack }) => (
	<ListContainer>
		<ListItem track={track} playTrack={playTrack} isActiveTrack />
	</ListContainer>
);

export const PlaylistContainer = ({ trackList = [] }) => {
	const [previousTrack, setPreviousTrack] = useState(null);
	const [currentTrack, setCurrentTrack] = useState(trackList[0]);
	const [isShowPlaylist, setIsShowPlaylist] = useState(false);
	const [isPlaylistOpen, setIsPlaylistOpen] = useState(false);
	const [
		activeTrackInAccordionHeader,
		setActiveTrackInAccordionHeader
	] = useState(null);

	const isPlayingNewTrack =
		previousTrack !== null && currentTrack?.src !== previousTrack?.src;

	useEffect(() => {
		setCurrentTrack(trackList[0]);
	}, [trackList.length]);

	const playlistBlockShowToggle = () => {
		setIsShowPlaylist((prevState) => !prevState);
		setIsPlaylistOpen(true);
	};
	const playlistOpenToggle = () => {
		setIsPlaylistOpen((prevState) => !prevState);
	};
	const playNewTrackFromList = (id) => {
		const foundTrack = trackList.find((track) => track?.id === id);
		setPreviousTrack(currentTrack);
		setCurrentTrack(foundTrack);
	};

	useEffect(() => {
		if (activeTrackInAccordionHeader) {
			return setActiveTrackInAccordionHeader(null);
		}
		setTimeout(() => {
			setActiveTrackInAccordionHeader(
				<AccordionHeader
					track={currentTrack}
					playTrack={playNewTrackFromList}
				/>
			);
		}, 300);
		return () => clearTimeout();
	}, [isPlaylistOpen]);

	if (!trackList.length) {
		return <AudioPlayer trackSrc={currentTrack?.src} />;
	}

	return (
		<>
			<div className={styles.playerAndTitleContainer}>
				<div className={styles.currentTrackFromPlayList}>
					{currentTrack?.title}
				</div>
				<InfoContainer
					onHandleClick={playlistBlockShowToggle}
					isShow={trackList.length}
				>
					<AudioPlayer
						trackSrc={currentTrack?.src}
						autoPlay={isPlayingNewTrack}
					/>
				</InfoContainer>
			</div>
			{!!isShowPlaylist && (
				<Accordion
					id={currentTrack?.id || ''}
					isOpen={isPlaylistOpen}
					setIsOpen={playlistOpenToggle}
					controlButton={<AccordionControl isOpen={isPlaylistOpen} />}
					headerComponent={activeTrackInAccordionHeader}
				>
					<ListContainer>
						{trackList.map((track) => (
							<ListItem
								track={track}
								playTrack={playNewTrackFromList}
								isActiveTrack={currentTrack?.id === track?.id}
							/>
						))}
					</ListContainer>
				</Accordion>
			)}
		</>
	);
};

PlaylistContainer.propTypes = {
	trackList: PropTypes.array.isRequired
};
ListContainer.propTypes = {
	children: PropTypes.object
};
ListItem.propTypes = {
	track: PropTypes.object.isRequired,
	playTrack: PropTypes.func.isRequired,
	isActiveTrack: PropTypes.bool
};
AccordionHeader.propTypes = {
	track: PropTypes.object.isRequired,
	playTrack: PropTypes.func.isRequired
};
AccordionControl.propTypes = {
	isOpen: PropTypes.bool.isRequired
};
